var React = require('react');

function MenuInline (props) {
    return React.createElement("path",props);
}

MenuInline.defaultProps = {"d":"M 2,15.000015 H 22 V 17 H 2 Z M 2,7 H 22 V 8.9999849 H 2 Z"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
